import type { MouseEvent } from 'react'
import { Box, Button, Header, Modal, Spacer, Text } from '@truepill/react-capsule'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import styled from 'styled-components'

type AdjustmentValidationFailedModalProps = {
  messages: string[]
}

const AdjustmentValidationFailedModal = ({ messages }: AdjustmentValidationFailedModalProps): JSX.Element => {
  const { dismissModal } = useModalContext()

  // Scanners end every scan with Enter, which "clicks" the focused button with detail 0.
  // Only a real pointer click (detail >= 1) acknowledges the modal.
  const acknowledge = (event: MouseEvent<HTMLButtonElement>) => {
    if (event.detail > 0) dismissModal()
  }

  return (
    <Modal
      aria-label="AdjustmentValidationFailedModal"
      overlayCss={{ zIndex: 999, background: 'rgba(24, 39, 75, 0.08)' }}
      css={{ width: '30rem', padding: '1.5rem' }}
      isOpen
      showCloseButton={false}
      onDismiss={() => {}}
    >
      <Header variant="2xl" as="h2" bold>
        Inventory adjustment will fail
      </Header>
      <Spacer size="md" />
      <Text>Tecsys inventory can&apos;t cover this adjustment. Fix the inventory, then try again.</Text>
      <Spacer size="md" />
      <StyledMessages>
        {messages.map(message => (
          <Text key={message} css={{ color: 'red' }} data-testid="adjustment-validation-message">
            {message}
          </Text>
        ))}
      </StyledMessages>
      <StyledBoxButtons>
        <Button size="sm" onClick={acknowledge}>
          Acknowledge
        </Button>
      </StyledBoxButtons>
    </Modal>
  )
}

const StyledMessages = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const StyledBoxButtons = styled(Box)`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
`

export default AdjustmentValidationFailedModal
